import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';

import rootReducer from '#/modules/infra/store/rootReducer';
import rootSaga from '#/modules/infra/store/rootSaga';
import { setSessionActorGetter } from '#/utils/auth/sessionActor';
import { setSessionExitDispatch } from '#/utils/auth/sessionExit';

const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: false,
      serializableCheck: false,
    }).concat(sagaMiddleware),
});

setSessionExitDispatch(store.dispatch);
setSessionActorGetter(() => store.getState().infra?.user?.id);

sagaMiddleware.run(rootSaga);

export default store;
